import React, { Component } from 'react';

export class ContactFormWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            submitting: false,
            submitted: false,
            form: { name: '', phone: '', email: '', message: '' },
            error: ''
        };
    }

    toggle = () => this.setState({ open: !this.state.open, submitted: false, error: '' });
    upd = (f, v) => this.setState({ form: { ...this.state.form, [f]: v } });

    submit = async () => {
        var { form } = this.state;
        if (!form.message.trim()) { this.setState({ error: 'กรุณากรอกข้อความ' }); return; }
        if (!form.name.trim()) { this.setState({ error: 'กรุณากรอกชื่อ' }); return; }
        this.setState({ submitting: true, error: '' });
        try {
            var r = await fetch('api/contact', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form)
            });
            if (!r.ok) throw new Error('send failed');
            this.setState({ submitted: true, submitting: false, form: { name: '', phone: '', email: '', message: '' } });
        } catch (e) {
            this.setState({ error: 'ส่งไม่สำเร็จ กรุณาลองใหม่', submitting: false });
        }
    }

    render() {
        var { open, submitting, submitted, form, error } = this.state;

        return (
            <div style={{ position: 'fixed', right: 20, bottom: 100, zIndex: 999998 }}>
                {open && (
                    <div style={{ position: 'absolute', bottom: 80, right: 0, width: 340, maxWidth: 'calc(100vw - 40px)', background: '#fff', borderRadius: 14, boxShadow: '0 10px 40px rgba(0,0,0,0.2)', overflow: 'hidden', animation: 'slideUp 0.25s ease-out' }}>
                        <div style={{ background: 'linear-gradient(135deg,#dc3545,#9d1a26)', color: '#fff', padding: '16px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div>
                                <div style={{ fontSize: 16, fontWeight: 800 }}><i className="fas fa-paper-plane"></i> ส่งข้อความถึงเรา</div>
                                <div style={{ fontSize: 11, opacity: 0.9, marginTop: 2 }}>ทีมงานจะติดต่อกลับโดยเร็ว</div>
                            </div>
                            <button onClick={this.toggle} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', width: 30, height: 30, borderRadius: '50%', cursor: 'pointer', fontSize: 18, lineHeight: 1 }}>×</button>
                        </div>

                        <div style={{ padding: 18 }}>
                            {submitted ? (
                                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                                    <div style={{ width: 60, height: 60, borderRadius: '50%', background: '#d4edda', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <i className="fas fa-check" style={{ color: '#28a745', fontSize: 28 }}></i>
                                    </div>
                                    <div style={{ fontSize: 16, fontWeight: 700, color: '#333' }}>ส่งข้อความเรียบร้อย</div>
                                    <div style={{ fontSize: 13, color: '#888', marginTop: 6 }}>ขอบคุณครับ ทีมงานจะติดต่อกลับโดยเร็ว</div>
                                    <button onClick={() => this.setState({ submitted: false })} className="btn btn-outline-secondary btn-sm mt-3">ส่งข้อความใหม่</button>
                                </div>
                            ) : (
                                <>
                                    <div className="mb-2">
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>ชื่อ *</label>
                                        <input className="form-control form-control-sm" value={form.name} onChange={e => this.upd('name', e.target.value)} placeholder="ชื่อ-นามสกุล" />
                                    </div>
                                    <div className="row g-2 mb-2">
                                        <div className="col-6">
                                            <label style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>เบอร์</label>
                                            <input className="form-control form-control-sm" value={form.phone} onChange={e => this.upd('phone', e.target.value)} placeholder="08x-xxx-xxxx" />
                                        </div>
                                        <div className="col-6">
                                            <label style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>อีเมล</label>
                                            <input className="form-control form-control-sm" value={form.email} onChange={e => this.upd('email', e.target.value)} placeholder="you@email.com" />
                                        </div>
                                    </div>
                                    <div className="mb-2">
                                        <label style={{ fontSize: 12, fontWeight: 600, color: '#555' }}>ข้อความ *</label>
                                        <textarea className="form-control form-control-sm" rows="4" value={form.message} onChange={e => this.upd('message', e.target.value)} placeholder="สอบถามข้อมูล / โปรแกรมที่สนใจ ..."></textarea>
                                    </div>
                                    {error && <div style={{ fontSize: 12, color: '#dc3545', marginBottom: 8 }}><i className="fas fa-exclamation-circle"></i> {error}</div>}
                                    <button onClick={this.submit} disabled={submitting} className="btn btn-danger w-100">
                                        {submitting ? <><i className="fas fa-spinner fa-spin"></i> กำลังส่ง...</> : <><i className="fas fa-paper-plane"></i> ส่งข้อความ</>}
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                )}

                <button onClick={this.toggle} title="ส่งข้อความ"
                    style={{ width: 60, height: 60, borderRadius: '50%', background: 'linear-gradient(135deg,#dc3545,#9d1a26)', color: '#fff', border: 'none', boxShadow: '0 6px 20px rgba(220,53,69,0.4)', cursor: 'pointer', fontSize: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'transform 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}>
                    <i className={open ? 'fas fa-times' : 'fas fa-comment-dots'}></i>
                </button>
            </div>
        );
    }
}
